import { ADSInputEvent, Checkbox } from '@appliedsystems/applied-design-system';
import { formatAddress } from '@appliedsystems/payments-core';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useAgencyDetailsStore } from 'src/store/AgencyDetail';
import { usePaymentsTranslation } from '../../hooks/usePaymentsTranslation';
import { PadAgreementData } from '../PadAgreement/PadAgreement';
import classes from './PadAgreementCheckbox.module.scss';

export const PadAgreementCheckbox = ({
  name,
  onChange,
  isChecked,
  isRecurring = false,
}: {
  name?: string;
  onChange?: (value: boolean) => void;
  isChecked?: boolean;
  isRecurring?: boolean;
}) => {
  const { t } = usePaymentsTranslation();
  const { data: agencyDetails } = useAgencyDetailsStore();

  const padAgreementLink = useMemo(() => {
    const brandLocation = formatAddress(agencyDetails?.brandLocation);
    const padAgreementData: PadAgreementData = {
      name: agencyDetails?.name,
      email: agencyDetails?.email,
      phone: agencyDetails?.phoneNumber,
      addressLine1: brandLocation?.addressLine1,
      addressLine2: brandLocation?.addressLine2,
      isRecurring,
    };
    return `/flow/pad-agreement?padAgreementData=${encodeURIComponent(JSON.stringify(padAgreementData))}`;
  }, [agencyDetails, isRecurring]);

  return (
    <div className={classes.checkboxWrapper}>
      <Checkbox
        type="reverse"
        {...(name && { name })}
        {...(onChange && {
          onChange: (e: ADSInputEvent) => onChange(e.target.value),
        })}
        {...(isChecked !== undefined && { value: isChecked })}
      >
        {isRecurring ? t('AUTHORIZE_PAD_AGREEMENT_RECURRING_PREFIX') : t('AUTHORIZE_PAD_AGREEMENT_ONE_TIME_PREFIX')}{' '}
        <Link to={padAgreementLink} target="_blank" rel="noopener noreferrer" className={classes.link}>
          {t('AUTHORIZE_PAD_AGREEMENT_LINK_TEXT')}
        </Link>{' '}
        {t('AUTHORIZE_PAD_AGREEMENT_SUFFIX')}
      </Checkbox>
    </div>
  );
};
